import React, { ReactNode } from 'react';

import {
  CmBox,
  CmButton,
  CmButtonDatePicker,
  CmFlex,
  CmFormControl,
  CmFormLabel,
  CmModal,
  CmModalFooter,
  CmSelectDigitsTime,
  CmText,
} from '@/components/uiParts';
import { deliveryServiceNameMap } from '@/domain/models/DeliveryService';
import { ConnectDeliveryService } from '@/pages/store-management/master-stores/service';
type Props = {
  text: string;
  targetDeliveryStore: ConnectDeliveryService;
  isOpen: boolean;
  integrationDate: Date;
  children?: ReactNode;
  handleInputIntegrationDate: (date: Date) => void;
  handleChangeTime: (
    time: string,
    targetMethod: 'setHours' | 'setMinutes'
  ) => void;
  onClose: () => void;
};

export const DeliveryStoreIntegrationModal: React.FC<Props> = ({
  text,
  isOpen,
  integrationDate,
  targetDeliveryStore,
  children,
  handleInputIntegrationDate,
  handleChangeTime,
  onClose,
}) => {
  return (
    <>
      <CmModal
        {...{ isOpen, onClose }}
        title={`${deliveryServiceNameMap[targetDeliveryStore]} 利用開始日`}
      >
        <CmBox padding="30px">
          <CmText>{text}</CmText>
          <CmFormControl mt="10px">
            <CmFormLabel isRequired fontWeight="bold">
              日時設定
            </CmFormLabel>
            <CmFlex alignItems="center">
              <CmButtonDatePicker
                selectedDate={integrationDate}
                onChange={handleInputIntegrationDate}
                dateFormat={'yyyy - MM - dd'}
                minDate={new Date()}
              />
              <CmBox ml="3" />
              <CmSelectDigitsTime
                date={integrationDate}
                handleChangeHour={(hour) => handleChangeTime(hour, 'setHours')}
                handleChangeMinutes={(minutes) =>
                  handleChangeTime(minutes, 'setMinutes')
                }
              />
            </CmFlex>
          </CmFormControl>
        </CmBox>
        <CmModalFooter>
          {children}
          {/*
           // @ts-ignore TS2590 */}
          <CmButton ml="3" variant="outline" onClick={onClose}>
            閉じる
          </CmButton>
        </CmModalFooter>
      </CmModal>
    </>
  );
};
